module.exports = __webpack_public_path__ + "static/media/6.e703149c.jpg";